import React from 'react';
import { LinearProgress } from '@material-ui/core';

const Loading = () => <LinearProgress data-testid="loading" />;

export { Loading };
